import { createContext, useContext, useReducer } from 'react';
import initialFriends from '../data/initialFriends';

const FriendsContext = createContext();

function reducer(state, action) {
  switch (action.type) {
    case 'showAddFriend':
      return { ...state, showAddFriend: !state.showAddFriend };

    case 'addFriend':
      return {
        ...state,
        friends: [...state.friends, action.payload],
        showAddFriend: false,
      };

    case 'selectedFriend':
      return {
        ...state,
        selectedFriend:
          state.selectedFriend?.id === action.payload.id ? null : action.payload,
      };

    case 'splitBill':
      return {
        ...state,
        friends: state.friends.map(friend =>
          friend.id === state.selectedFriend.id
            ? { ...friend, balance: friend.balance + action.payload }
            : friend,
        ),
        selectedFriend: null,
      };

    default:
      throw new Error('Unknown action type');
  }
}

const initialState = {
  friends: initialFriends,
  showAddFriend: false,
  selectedFriend: null,
};

function FriendsProvider({ children }) {
  const [{ friends, showAddFriend, selectedFriend }, dispatch] = useReducer(
    reducer,
    initialState,
  );

  return (
    <FriendsContext.Provider
      value={{ friends, showAddFriend, selectedFriend, dispatch }}
    >
      {children}
    </FriendsContext.Provider>
  );
}

function useFriends() {
  const context = useContext(FriendsContext);
  if (!context) throw new Error('useFriends must be used inside FriendsProvider');
  return context;
}

export { FriendsProvider, useFriends };
